(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-bath-boxes"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ld-bath'))customElements.define('ld-bath',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.busy=false;this.button=this.querySelector('button');this.status=this.querySelector('.ldb-status');
this.addEventListener('change',()=>this.update());
this.button.addEventListener('click',()=>this.add());
this.querySelectorAll('input[name="bath-scent"],input[name="bath-type"]').forEach(i=>{const key=i.name==='bath-type'?'type':'scent';if(!Array.from(this.querySelectorAll('article')).some(a=>a.dataset[key]===i.value)){i.disabled=true;i.parentElement.querySelector('span').append(' · bald');}});
this.update();
}
update(){
const values=n=>Array.from(this.querySelectorAll('input[name="'+n+'"]:checked'),i=>i.value);
const types=values('bath-type'),scents=values('bath-scent');let visible=0;
this.querySelectorAll('article').forEach(a=>{a.hidden=(types.length&&!types.includes(a.dataset.type))||(scents.length&&!scents.includes(a.dataset.scent));if(a.hidden)a.querySelectorAll('input').forEach(i=>i.checked=false);else visible++});
this.querySelector('.ldb-empty').hidden=visible>0;
const chosen=Array.from(this.querySelectorAll('input[name="bath-variant"]:checked'));
this.querySelector('.ldb-total').textContent=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(chosen.reduce((s,i)=>s+Number(i.dataset.price),0)/100);
this.button.disabled=this.busy||!chosen.length;
}
async add(){
if(this.busy)return;
const items=Array.from(this.querySelectorAll('input[name="bath-variant"]:checked:not(:disabled)'),i=>({id:i.value,quantity:1}));
if(!items.length)return;
this.busy=true;this.update();this.status.textContent='Deine Essentials werden hinzugefügt …';
try{
const root=this.dataset.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Bitte prüfe deine Auswahl.');
window.location.assign(root+'cart');
}catch(error){this.status.textContent=error.message||'Das hat nicht geklappt. Bitte versuche es erneut.';this.busy=false;this.update()}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-bath-essentials"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ld-bath'))customElements.define('ld-bath',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.busy=false;this.button=this.querySelector('button');this.status=this.querySelector('.ldb-status');
this.addEventListener('change',()=>this.update());
this.button.addEventListener('click',()=>this.add());
this.querySelectorAll('input[name="bath-scent"],input[name="bath-type"]').forEach(i=>{const key=i.name==='bath-type'?'type':'scent';if(!Array.from(this.querySelectorAll('article')).some(a=>a.dataset[key]===i.value)){i.disabled=true;i.parentElement.querySelector('span').append(' · bald');}});
this.update();
}
update(){
const values=n=>Array.from(this.querySelectorAll('input[name="'+n+'"]:checked'),i=>i.value);
const types=values('bath-type'),scents=values('bath-scent');let visible=0;
this.querySelectorAll('article').forEach(a=>{a.hidden=(types.length&&!types.includes(a.dataset.type))||(scents.length&&!scents.includes(a.dataset.scent));if(a.hidden)a.querySelectorAll('input').forEach(i=>i.checked=false);else visible++});
this.querySelector('.ldb-empty').hidden=visible>0;
const chosen=Array.from(this.querySelectorAll('input[name="bath-variant"]:checked'));
this.querySelector('.ldb-total').textContent=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(chosen.reduce((s,i)=>s+Number(i.dataset.price),0)/100);
this.button.disabled=this.busy||!chosen.length;
}
async add(){
if(this.busy)return;
const items=Array.from(this.querySelectorAll('input[name="bath-variant"]:checked:not(:disabled)'),i=>({id:i.value,quantity:1}));
if(!items.length)return;
this.busy=true;this.update();this.status.textContent='Deine Essentials werden hinzugefügt …';
try{
const root=this.dataset.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Bitte prüfe deine Auswahl.');
window.location.assign(root+'cart');
}catch(error){this.status.textContent=error.message||'Das hat nicht geklappt. Bitte versuche es erneut.';this.busy=false;this.update()}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-bath-film"] && !Shopify.designMode) return;
  try {
    
function initBathFilm(scope){
scope.querySelectorAll('.ld-bath-film video').forEach(video=>{
if(video.dataset.autostartReady)return;
video.dataset.autostartReady='true';
video.defaultMuted=true;
video.muted=true;
video.playsInline=true;
video.autoplay=true;
const start=()=>{
if(document.hidden||!video.paused)return;
video.muted=true;
const attempt=video.play();
if(attempt)attempt.catch(()=>{});
};
video.addEventListener('loadeddata',start);
video.addEventListener('canplay',start);
window.addEventListener('pageshow',start);
document.addEventListener('visibilitychange',start);
document.addEventListener('pointerdown',start,{once:true,passive:true});
document.addEventListener('keydown',start,{once:true});
const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting))start()},{threshold:0.1});
observer.observe(video);
start();
});
}
initBathFilm(document);
document.addEventListener('shopify:section:load',event=>initBathFilm(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-bath-packaging"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ld-bath'))customElements.define('ld-bath',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.busy=false;this.button=this.querySelector('button');this.status=this.querySelector('.ldb-status');
this.addEventListener('change',()=>this.update());
this.button.addEventListener('click',()=>this.add());
this.querySelectorAll('input[name="bath-scent"],input[name="bath-type"]').forEach(i=>{const key=i.name==='bath-type'?'type':'scent';if(!Array.from(this.querySelectorAll('article')).some(a=>a.dataset[key]===i.value)){i.disabled=true;i.parentElement.querySelector('span').append(' · bald');}});
this.update();
}
update(){
const values=n=>Array.from(this.querySelectorAll('input[name="'+n+'"]:checked'),i=>i.value);
const types=values('bath-type'),scents=values('bath-scent');let visible=0;
this.querySelectorAll('article').forEach(a=>{a.hidden=(types.length&&!types.includes(a.dataset.type))||(scents.length&&!scents.includes(a.dataset.scent));if(a.hidden)a.querySelectorAll('input').forEach(i=>i.checked=false);else visible++});
this.querySelector('.ldb-empty').hidden=visible>0;
const chosen=Array.from(this.querySelectorAll('input[name="bath-variant"]:checked'));
this.querySelector('.ldb-total').textContent=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(chosen.reduce((s,i)=>s+Number(i.dataset.price),0)/100);
this.button.disabled=this.busy||!chosen.length;
}
async add(){
if(this.busy)return;
const items=Array.from(this.querySelectorAll('input[name="bath-variant"]:checked:not(:disabled)'),i=>({id:i.value,quantity:1}));
if(!items.length)return;
this.busy=true;this.update();this.status.textContent='Deine Essentials werden hinzugefügt …';
try{
const root=this.dataset.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
const result=await response.json();if(!response.ok)throw new Error(result.description||'Bitte prüfe deine Auswahl.');
window.location.assign(root+'cart');
}catch(error){this.status.textContent=error.message||'Das hat nicht geklappt. Bitte versuche es erneut.';this.busy=false;this.update()}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovely-day-pflegekompass"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ld-care-compass')){
  customElements.define('ld-care-compass',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;
      this.dataset.ready='true';
      const tabs=Array.from(this.querySelectorAll('[role="tab"]'));
      const panels=Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const activate=(index,focus=false)=>{
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
        if(focus)tabs[index].focus();
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(index));
        tab.addEventListener('keydown',event=>{
          let next=index;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          else return;
          event.preventDefault();activate(next,true);
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
